import { __assign, __spreadArrays } from "tslib";
export var composeMapper = function () { return function (originalMapper, _a, mapperFunc) {
    var add = _a.add, _b = _a.remove, remove = _b === void 0 ? [] : _b;
    var deps = __spreadArrays(Object.keys(originalMapper.deps), add).filter(function (dependency) { return !remove.includes(dependency); })
        .reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[key] = true, _a)));
    }, {});
    var resolver = function (data, carmiData) { return mapperFunc(originalMapper.resolver, data, carmiData); };
    return {
        deps: deps,
        resolver: resolver,
    };
}; };
//# sourceMappingURL=composeMapper.js.map